<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :customBtns="customBtns"
    titleKey="locales.name"
    orderBy="sequence"
    orderWay="asc"
  >
  </WsRead>
</template>

<script>
import model from "@/models/area";
export default {
  data(){
    return {
      modelName: model.modelName,
      label: model.label,
      localeMode: true,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                fields: ["locales"],
              },
            ],
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "設定",
                fields: ["sequence"],
              },
            ],
          },
        ],
      },
      customBtns: [
        {
          title: `查看子地區`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-eye",
          to: `${this.$route.params.id}/area_sections`,
        },
        {
          title: `編輯子地區`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-pencil",
          to: `${this.$route.params.id}/area_sections/update`,
        },
      ]
    }
  },
};
</script>